export var ServiceAccountScope;
(function (ServiceAccountScope) {
    ServiceAccountScope["SCIM_MANAGE"] = "scim:manage";
    ServiceAccountScope["ORG_ADMIN"] = "org:admin";
    ServiceAccountScope["ORG_EDIT"] = "org:edit";
    ServiceAccountScope["ORG_READ"] = "org:read";
})(ServiceAccountScope || (ServiceAccountScope = {}));
//# sourceMappingURL=types.js.map